import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-daa5c6a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ss-div-pai"
}
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-9 ant-col-xl-9" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ss-div-titulo" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo" }, "Bem vindo a plataforma NeoX"),
  /*#__PURE__*/_createElementVNode("span", { class: "ss-subtitulo" }, "Antes de começar precisamos ajustar algumas coisas")
], -1))
const _hoisted_5 = { class: "ss-div-imagem" }
const _hoisted_6 = { class: "ant-col ant-col-xs-15 ant-col-xl-15" }
const _hoisted_7 = { class: "ss-div-processo" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-processo" }, "Separamos aqui alguns tópicos para acelerar seu início no mundo NeoX", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_e_r_p_layout_vazio = _resolveComponent("e-r-p-layout-vazio")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_configuracao_inicial_etapas = _resolveComponent("configuracao-inicial-etapas")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_e_r_p_layout_vazio),
    (!_ctx.storeSistema.state.carregando && !_ctx.telaBase.carregando)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_inline_svg, { src: "/static/img/ilustracoes/configuracao-inicial.svg" })
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(_component_configuracao_inicial_etapas)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}